import {createContext} from "react";

export const SllMatchContext = createContext({myMatch:{}, match:{},data:{}});